export default "__VITE_ASSET__4680435c__"